// data/templates.js
export const templates = [
  { 
    name: 'skin_1', 
    bgImage: '/7.png', 
    titleColor: 'text-red-600',
    headerStyle: 'border-l-4 border-red-600',
    // 개별 요소별 커스텀 스타일
    customStyles: {
      title: { fontSize: '36px', fontWeight: 'bold', fontFamily: 'Arial' },
      companyInfo: { fontSize: '14px', lineHeight: '1.6', color: '#333' },
      customerInfo: { fontSize: '14px', lineHeight: '1.6', color: '#333' },
      tableHeader: { fontSize: '12px', fontWeight: 'bold', backgroundColor: '#f5f5f5' },
      tableBody: { fontSize: '11px', lineHeight: '1.4' },
      totalSection: { fontSize: '14px', fontWeight: 'bold' },
      notes: { fontSize: '12px', fontStyle: 'italic', color: '#666' }
    }
  },
  { 
    name: 'skin_2', 
    bgImage: '/6.png', 
    titleColor: 'text-blue-600',
    headerStyle: 'border-b-2 border-blue-800',
    customStyles: {
      title: { fontSize: '40px', fontWeight: 'bold', fontFamily: 'Times New Roman' },
      companyInfo: { fontSize: '13px', lineHeight: '1.5', color: '#1e3a8a' },
      customerInfo: { fontSize: '13px', lineHeight: '1.5', color: '#1e3a8a' },
      tableHeader: { fontSize: '11px', fontWeight: 'bold', backgroundColor: '#dbeafe' },
      tableBody: { fontSize: '10px', lineHeight: '1.3' },
      totalSection: { fontSize: '13px', fontWeight: 'bold', color: '#1e3a8a' },
      notes: { fontSize: '11px', color: '#64748b' }
    }
  },
  { 
    name: 'skin_3', 
    bgImage: '/12.png', 
    titleColor: 'text-orange-800',
    headerStyle: 'mt-6',
    customStyles: {
      title: { fontSize: '36px', fontWeight: 'bold', fontFamily: 'Helvetica' },
      companyInfo: { fontSize: '14px', lineHeight: '1.6', color: '#ea580c' },
      customerInfo: { fontSize: '14px', lineHeight: '1.6', color: '#ea580c' },
      tableHeader: { fontSize: '12px', fontWeight: 'bold', backgroundColor: '#fed7aa' },
      tableBody: { fontSize: '11px', lineHeight: '1.4' },
      totalSection: { fontSize: '15px', fontWeight: 'bold', color: '#ea580c' },
      notes: { fontSize: '12px', color: '#9a3412' }
    }
  },
  { 
    name: 'skin_4', 
    bgImage: '/21.png', 
    titleColor: 'text-gray-800',
    headerStyle: 'text-center',
    customStyles: {
      title: { fontSize: '48px', fontWeight: 'bold', fontFamily: 'Roboto' },
      companyInfo: { fontSize: '14px', lineHeight: '1.6', color: '#374151' },
      customerInfo: { fontSize: '14px', lineHeight: '1.6', color: '#374151' },
      tableHeader: { fontSize: '12px', fontWeight: 'bold', backgroundColor: '#f3f4f6', color: '#1f2937' },
      tableBody: { fontSize: '11px', lineHeight: '1.4' },
      totalSection: { fontSize: '15px', fontWeight: 'bold', color: '#1f2937' },
      notes: { fontSize: '12px', color: '#6b7280' }
    }
  },
  { 
    name: 'skin_5', 
    bgImage: '/16.png', 
    titleColor: 'text-gray-900',
    headerStyle: 'border-b-2 border-gray-900',
    customStyles: {
      title: { fontSize: '36px', fontWeight: 'normal', fontFamily: 'Georgia' },
      companyInfo: { fontSize: '13px', lineHeight: '1.5', color: '#111827' },
      customerInfo: { fontSize: '13px', lineHeight: '1.5', color: '#111827' },
      tableHeader: { fontSize: '11px', fontWeight: 'bold', backgroundColor: '#f9fafb' },
      tableBody: { fontSize: '10px', lineHeight: '1.3' },
      totalSection: { fontSize: '14px', fontWeight: 'normal', color: '#111827' },
      notes: { fontSize: '11px', color: '#4b5563' }
    }
  },
  { 
    name: 'skin_6', 
    bgImage: '/11.png', 
    titleColor: 'text-red-800',
    headerStyle: 'border-b-3 border-red-700',
    customStyles: {
      title: { fontSize: '32px', fontWeight: 'bold', fontFamily: 'Verdana' },
      companyInfo: { fontSize: '14px', lineHeight: '1.6', color: '#000000' },
      customerInfo: { fontSize: '14px', lineHeight: '1.6', color: '#000000' },
      tableHeader: { fontSize: '12px', fontWeight: 'bold', backgroundColor: '#ffffff', borderBottom: '2px solid #000' },
      tableBody: { fontSize: '11px', lineHeight: '1.4' },
      totalSection: { fontSize: '16px', fontWeight: 'bold', color: '#000000' },
      notes: { fontSize: '12px', color: '#333333' }
    }
  }
];